<template>
    <div class="col-md-12">
        <templateBaseForm :current-template="currentTemplate" :is-in-use="isInUse" :is-ready="isReady" :satisfaction-survey-status="satisfactionSurveyStatus" ></templateBaseForm>
        <templateCriteriaQuestionForm :is-in-use="isInUse" :is-ready="isReady" :current-template="currentTemplate" :satisfaction-survey-status="satisfactionSurveyStatus" ></templateCriteriaQuestionForm>
    </div>
</template>

<script>
    import store from 'store'
    import TemplateBaseForm from 'components/TemplateBaseForm'
    import TemplateCriteriaQuestionForm from 'components/TemplateCriteriaQuestionForm'

    export default {
        components: {
            TemplateBaseForm,
            TemplateCriteriaQuestionForm
        },
        computed: {
            deletedCriterias: function() {
                return this.$store.state.admin.deletedCriterias;
            },
            deletedQuestions: function() {
                return this.$store.state.admin.deletedQuestions;
            },
            currentTemplate:  function() {
                return this.$store.state.admin.currentTemplate;
            },
            isInUse: function() {
                return !!this.currentTemplate.instances.length;
            },
            isReady: function() {
                return this.currentTemplate.isReady;
            },
            satisfactionSurveyStatus: function()  {
                return this.$store.state.admin.currentTemplate.satisfactionSurvey;
            },
            formMode: function() {
                return this.$route.meta.mode;
            }
        },
        methods: {
            setTargetId(templateId, targetId) {
                this.$store.dispatch('setTargetTemplate', {
                    templateId: templateId,
                    targetId: targetId,
                    callbacks: {}
                });
            },
            saveCriteriaRequest(templateId, criteria, index, creation) {
                this.$store.dispatch(creation ? 'createCriteria' : 'updateCriteria', {
                    templateId: templateId,
                    newCriteria: criteria,
                    position: index + 1,
                    callbacks: {}
                });
            },
            deleteCriteriaRequest(criteriaId)  {
                this.$store.dispatch('deleteCriteria', {
                    criteriaId: criteriaId,
                    callbacks: {}
                });
            },
            saveQuestionRequest(templateId, question, index, creation) {
                this.$store.dispatch(creation ? 'createQuestion' : 'updateQuestion', {
                    templateId: templateId,
                    newQuestion: question,
                    position: index + 1,
                    callbacks: {}
                });
            },
            deleteQuestionRequest(questionId)  {
                this.$store.dispatch('deleteQuestion', {
                    questionId: questionId,
                    callbacks: {}
                });
            },
            saveTemplate() {
                let successCallback = (templateId) => {
                    this.currentTemplate.criterias.forEach(function(criteria, index) {
                        this.saveCriteriaRequest(templateId, criteria, index, !criteria.id);
                    }, this);
                    if (this.currentTemplate.satisfactionSurvey != 'NONE') {
                        this.currentTemplate.surveyQuestions.forEach(function(question, index) {
                            this.saveQuestionRequest(templateId, question, index, !question.id || this.formMode == 'create');
                        }, this);
                    }
                    if (this.formMode == 'edit')  {
                        this.deletedCriterias.forEach(function(deletedCriteria) {
                            this.deleteCriteriaRequest(deletedCriteria);
                        }, this);
                        this.deletedQuestions.forEach(function(deletedQuestion) {
                            this.deleteQuestionRequest(deletedQuestion);
                        }, this);
                    }

                    this.$router.push({ name: 'TemplateList' });
                    let alertText = "";
                    if (this.formMode == 'default') {
                        alertText = "Le modèle par défaut a été mis à jour avec succès.";
                    }
                    else    {
                        let textPatch = this.formMode == 'create' ? 'créée' : 'mise à jour';
                        alertText = "La grille d'audit «" + this.currentTemplate.title + '» a été ' + textPatch + ' avec succès.'; 
                    }

                    this.$store.commit('ALERT_DATA_UPDATED', {
                        text: alertText,
                        type: 'success'
                    });
                };

                this.$store.dispatch(this.formMode == "create" || !this.currentTemplate.id ? 'createTemplate' : 'updateTemplate', {
                    newTemplate: this.currentTemplate,
                    callbacks: {
                        success: successCallback
                    }
                });
            }
        },
        data: function()  {
            return {
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                backText: "Retour aux grilles d'audit",
                pathData: {
                    name: "TemplateList"
                },
                buttonData: [{
                    text: "Sauvegarder",
                    actionToCall: null
                }]
            });
        },
        mounted()   {
            this.$emit('navbarUpdate', {
                backText: "Retour aux grilles d'audit",
                pathData: {
                    name: "TemplateList"
                },
                buttonData: [{
                    text: "Sauvegarder",
                    actionToCall: this.saveTemplate
                }]
            });
        }
    };
</script>

<style>
</style>